import React, { useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import Container from "../ui/Container";
import Icon from "../ui/Icon";
import mapData from "../../data/countries.json";

const countries = ["Kenya", "Tanzania", "Congo", "Uganda", "Rwanda", "Burundi"];

const Countries = () => {
  const [hovered, setHovered] = useState("");

  return (
    <section className="bg-surface py-20 md:py-section-gap">
      <Container>
        <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2">
          <div>
            <h2 className="mb-6 font-headline-lg text-headline-lg uppercase text-primary">
              Countries We Work In
            </h2>
            <p className="mb-6 font-body-lg text-body-lg leading-relaxed text-on-surface-variant">
              At Cargo Power Logistics, we are more than just a logistics
              company—we are the engine that powers business growth and
              international trade across East Africa and beyond.
            </p>
            <ul className="grid grid-cols-2 gap-3">
              {countries.map((country) => (
                <li
                  key={country}
                  className="flex items-center font-body-md text-body-md text-on-surface"
                >
                  <Icon
                    name="location_on"
                    fill
                    className="mr-2 text-xl text-primary-container"
                  />
                  {country}
                  {hovered === country && (
                    <span className="ml-2 h-2 w-2 animate-pulse rounded-full bg-primary-container" />
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="overflow-hidden rounded-2xl">
            <ComposableMap>
              <Geographies geography={mapData}>
                {({ geographies }) =>
                  geographies.map((geo) => (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      onMouseEnter={() => setHovered(geo.properties.name)}
                      onMouseLeave={() => setHovered("")}
                      stroke="#fff8f5"
                      strokeWidth={0.5}
                      style={{
                        default: { fill: "#ff8c00", outline: "none" },
                        hover: { fill: "#904d00", outline: "none" },
                        pressed: { fill: "#904d00", outline: "none" },
                      }}
                    />
                  ))
                }
              </Geographies>
            </ComposableMap>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Countries;
